import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      const userToken = localStorage.getItem('userToken');
      if (userToken) {
        next();
      } else {
        next('/login'); // Redirect to login if user token doesn't exist
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue')
  },
  {
    path: '/labels',
    name: 'labels',
    component: () => import(/* webpackChunkName: "labels" */ '../views/LabelView.vue')
  },
  {
    path: '/purchases',
    name: 'purchases',
    component: () => import(/* webpackChunkName: "purchases" */ '../views/PurchasesView.vue')
  },
  {
    path: '/serial-search/',
    name: 'serial-search',
    component: () => import(/* webpackChunkName: "serial-search" */ '../views/SerialSearchView.vue')
  },
  {
    path: '/box-search/',
    name: 'box-search',
    component: () => import(/* webpackChunkName: "box-search" */ '../views/PackedSearchView.vue')
  },
  {
    path: '/reuse-serials/',
    name: 'reuse-serials',
    component: () => import(/* webpackChunkName: "reuse-serials" */ '../views/ReuseSerialsView.vue')
  },
  {
    path: '/filemanager/',
    name: 'filemanager',
    component: () => import(/* webpackChunkName: "filemanager" */ '../views/FileDownloadView.vue')
  },
  {
    path: '/upload-files/',
    name: 'upload-files',
    component: () => import(/* webpackChunkName: "upload-files" */ '../views/LogoUploadView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/SettingsView.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
